import { useParams } from "react-router";
import { CustomCircularProgressFullScreen } from "../../../components/CustomCircularProgress";
import useGetBase64 from "../../../hooks/reversal/useGetBase64";
import useGetReversalForms from "../../../hooks/reversal/useGetFormImage";
import { useEffect } from "react";
const ReversalDownload = () => {
  const params = useParams();
  const { data, isLoading } = useGetReversalForms(params.case ?? "");
  const { getData64 } = useGetBase64(); // Atualize para o seu hook correspondente
  const handleDownload = (idCase: string, fileName: string) => {
    getData64(idCase, fileName).then((resp: any) => {
      if (resp.status === 200) {
        const link = document.createElement("a");
        link.href = `data:application/octet-stream;base64,${resp?.data.fileBytesBase64}`;
        link.download = resp.data.attachmentFileName;
        link.click();        
      }
    });
  };
  useEffect(() => {
    if (data) {
      const item = data.find((f) => f.attachmentDescription === `#${params.type}`);
      if (item) {
        handleDownload(item.caseId, item.attachmentIdEncrypted);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);
  return isLoading && <CustomCircularProgressFullScreen />;
};
export default ReversalDownload;
